export default {
    OrderShortageManagement: {
        Order: '订单号',
        number: '客户订单号/内部订单号，多个逗号隔开',
        // name: '商品名称/编码',
        SKU: 'SKU编码',
        source: '订单来源',
        Buyer: '买家昵称',
        Consignee: '收货人姓名',
        mobile: '收货人手机',
        comments: '买家备注',
        Notes: '商家备注',
        there: '有无赠品',
        party: '三方下单时间',
        Start: '开始日期',
        End: '结束日期',
        Payment: '支付时间',
        Internal: '内部创单时间',
        time: '预计发货时间',
        reallocate: '重新预占',
        form: {
            number: '客户订单号',
            order: '内部订单号',
            Label: '标签',
            Status: '审核状态',
            Sales: '销售店铺',
            channel: '销售渠道',
            source: '订单来源',
            line: '商品行数量',
            Shortage: '缺货数量',
            nickname: '买家昵称',
            comments: '买家备注',
            Merchant: '商家备注',
            name: '收货人姓名',
            mobile: '收货人手机号',
            address: '收货人地址',
            amount: '商品总金额',
            Buyer: '买家应付',
            cost: '商品总成本',
            party: '三方下单时间',
            Payment: '支付时间',
            creation: '内部创单时间',
            delivery: '预计发货时间',
            Pending: '挂起状态',
            there: '有无赠品',
            Product: '商品信息',
        }
    }
};
